import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import * as CompanyLogoActions from './company-logo.actions';

export const companyLogoFeatureKey = 'company-logo';

export interface State extends EntityState<null> {
  // additional entities state properties
  logoUrl: string;
  loading: boolean;
  creating: boolean;
  updating: boolean;
  deleting: boolean;
  error: any;
}

export const adapter: EntityAdapter<null> = createEntityAdapter<null>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  logoUrl: null,
  loading: false,
  creating: false,
  updating: false,
  deleting: false,
  error: null,
});

export const companyLogoReducer = createReducer(
  initialState,
  on(CompanyLogoActions.loadCompanyLogo, (state) => ({ ...state, loading: true })),
  on(CompanyLogoActions.loadCompanyLogoSuccess, (state, action) => ({ ...state, logoUrl: action.url, loading: false })),
  on(CompanyLogoActions.loadCompanyLogoFailure, (state, action) => ({ ...state, error: action.error, loading: false })),
  on(CompanyLogoActions.updateCompanyLogo, (state, action) => ({ action, ...state, updating: true })),
  on(CompanyLogoActions.updateCompanyLogoSuccess, (state, action) => ({
    ...state,
    logoUrl: action.url,
    updating: false,
  })),
  on(CompanyLogoActions.updateCompanyLogoFailure, (state, action) => ({
    ...state,
    error: action.error,
    updating: false,
  })),
  on(CompanyLogoActions.deleteCompanyLogo, (state, action) => ({ action, ...state, deleting: true })),
  on(CompanyLogoActions.deleteCompanyLogoSuccess, (state) => ({
    ...state,
    logoUrl: null,
    deleting: false,
  })),
  on(CompanyLogoActions.deleteCompanyLogoFailure, (state, action) => ({
    ...state,
    error: action.error,
    deleting: false,
  })),
  on(CompanyLogoActions.clearCompanyLogo, (state) => adapter.removeAll(state))
);

export const selectCompanyLogoState = createFeatureSelector<State>(companyLogoFeatureKey);
export const selectCompanyLogoUrl = createSelector(selectCompanyLogoState, (state) => state.logoUrl);
export const selectCompanyLogoLoading = createSelector(selectCompanyLogoState, (state) => state.loading);
